import ToneOfVoice from "@/models/tone-of-voice/toneOfVoice";
import { useItemsCrud } from "./useItemsCrud";
import { useQueryClient } from "@tanstack/react-query";

const useToneOfVoice = () => {
  const toneOfVoiceCrud = useItemsCrud<ToneOfVoice>(
    ["toneOfVoice"],
    (services) => services.toneOfVoice
  );

  const queryClient = useQueryClient();

  const fetchToneOfVoices = (params: {
    pageNumber: number;
    pageSize: number;
    search: string;
    sortAscending: boolean;
    sortBy: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filters: any[];
  }) => {
    return toneOfVoiceCrud.useQueryPagination(params);
  };

  const invalidateQueries = () => {
    queryClient.invalidateQueries({ queryKey: ["toneOfVoice"] });
  };

  return {
    ...toneOfVoiceCrud,
    fetchToneOfVoices,
    invalidateQueries,
  };
};
export default useToneOfVoice;
